import { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("hd_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("hd_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me").then((r) => {
      setUser(r.data);
      localStorage.setItem("hd_user", JSON.stringify(r.data));
    }).catch(() => {
      localStorage.removeItem("hd_token");
      localStorage.removeItem("hd_user");
      setUser(null);
    }).finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("hd_token", r.data.token);
    localStorage.setItem("hd_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };

  const register = async (email, name, password) => {
    const r = await api.post("/auth/register", { email, name, password, role: "agent" });
    localStorage.setItem("hd_token", r.data.token);
    localStorage.setItem("hd_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };

  const acceptSession = (token, u) => {
    localStorage.setItem("hd_token", token);
    localStorage.setItem("hd_user", JSON.stringify(u));
    setUser(u);
  };

  const logout = () => {
    localStorage.removeItem("hd_token");
    localStorage.removeItem("hd_user");
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, acceptSession }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
